<template>
  <div>
    <v-row>
      <v-col cols="4">
        <v-text-field
          outlined
          hide-details
          class="required"
          autocomplete="off"
          label="CPF/CNPJ rementente"
          v-mask="['###.###.###-##', '##.###.###/####-##']"
          :error="$v.contratacao.coleta.cpfCnpj.$error"
          @blur="$v.contratacao.coleta.cpfCnpj.$touch()"
          v-model="contratacao.coleta.cpfCnpj"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          outlined
          hide-details
          class="required"
          autocomplete="off"
          label="CPF/CNPJ destinatário"
          v-mask="['###.###.###-##', '##.###.###/####-##']"
          :error="$v.contratacao.entrega.cpfCnpj.$error"
          @blur="$v.contratacao.entrega.cpfCnpj.$touch()"
          v-model="contratacao.entrega.cpfCnpj"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <px-select-enum v-model="contratacao.localPagamento"
                        @blur="$v.contratacao.localPagamento.$touch()"
                        :error="$v.contratacao.localPagamento.$error"
                        class="required"
                        :items="locaisPagamento"
                        label="Pagador"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { isValid as isValidCpf } from '@/utils/validate-cpf';
import { isValid as isValidCnpj } from '@/utils/validate-cnpj';
import { onlyNumbers } from '@/utils/regex-utils';
import validationMixin from '@/mixins/validation-mixin';
import { LocalPagamentoFrete } from 'px-business-components';

function validateCnpj(value) {
  if (!value) {
    return false;
  }
  const valor = onlyNumbers(value);
  if (valor.length <= 11) {
    return isValidCpf(value);
  }
  return isValidCnpj(value);
}

export default {
  mixins: [validationMixin],
  props: {
    contratacao: Object,
  },
  data() {
    return {
      locaisPagamento: LocalPagamentoFrete.values,
    };
  },
  methods: {
    onFileLoad(loading) {
      this.hasFileLoading = loading;
    },
  },
  validations: {
    contratacao: {
      localPagamento: {
        required,
      },
      coleta: {
        cpfCnpj: {
          required,
          validateCnpj,
        },
      },
      entrega: {
        cpfCnpj: {
          required,
          validateCnpj,
        },
      },
    },
  },
};
</script>
